import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@mui/material';
var RichTextViewer = function (_a) {
    var content = _a.content, _b = _a.compact, compact = _b === void 0 ? false : _b;
    if (!content) {
        return null;
    }
    return (_jsx(Box, { dangerouslySetInnerHTML: { __html: content }, sx: {
            border: !compact ? '1px solid #ccc' : undefined,
            padding: !compact ? '10px' : undefined,
            borderRadius: '6px',
            '& *': { marginBottom: '8px' },
            '& ul, & ol': { paddingLeft: '20px' },
            '& a': { color: 'blue', textDecoration: 'underline' },
        } }));
};
export default RichTextViewer;
